import PageNotFound from "@/components/common/page-not-found/page-not-found";
import Layout from "@/layout/layout";
import { syteTrackEvent } from "@/lib/syte";
import { wrapper } from "@/store";
import { selectAuth } from "@/store/slices/auth";
import {
  setIgnoreCommonTitle,
  setMeta,
  setOg,
  setPath,
  setSchemas,
  setTitle,
} from "@/store/slices/helmet";
import { fetchPageBySlug, selectPage } from "@/store/slices/page";
import React, { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";

const Page = () => {
  const pageState = useSelector(selectPage);
  const authState = useSelector(selectAuth);

  useEffect(() => {
    if (!authState.isUserLoading) {
      syteTrackEvent({
        name: "fe_page_view",
        tag: "ecommerce",
        osh_id: authState.user?.uuid,
      });
    }
  }, [authState.isUserLoading, authState.user?.uuid]);

  return (
    <>
      <div>
        {!!pageState.data && (
          <div
            dangerouslySetInnerHTML={{
              __html: pageState.data.content,
            }}
          ></div>
        )}
      </div>
    </>
  );
};

Page.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ params, resolvedUrl }) => {
      if (!params?.page) {
        return { notFound: true };
      }
      store.dispatch(setPath(resolvedUrl));
      const { payload: page } = await store.dispatch(
        fetchPageBySlug(params.page as string)
      );
      if (!page) {
        return { notFound: true };
      }
      store.dispatch(setTitle(page.title));
      store.dispatch(
        setMeta({
          title: page.meta_title,
          description: page.meta_description,
          keywords: page.meta_keywords,
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: page.meta_title,
          description: page.meta_description,
          image: "",
        })
      );
      store.dispatch(setIgnoreCommonTitle(true));
      if (page.schema) store.dispatch(setSchemas([page.schema]));

      return {
        props: {},
      };
    }
);

export default Page;
